import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import { HttpClient } from '@angular/common/http';
import {OAuthService} from 'angular-oauth2-oidc';

@Component({standalone: false,
  selector: 'app-auth-callback',
  templateUrl: './auth-callback.component.html',
  styleUrls: ['./auth-callback.component.css']
})
export class AuthCallbackComponent implements OnInit {
  content: any;

  constructor(
    private readonly router: Router,
    private readonly oauthService: OAuthService,
    private readonly http: HttpClient) {
  }

  async ngOnInit() {
    const returnUrl = localStorage.getItem('returnUrl');
    if (returnUrl) {
      this.router.navigateByUrl(returnUrl);
    } else {
      this.router.navigateByUrl('/home');
    }
  }

}
